import { array, option, record } from 'fp-ts';
import { flow, pipe } from 'fp-ts/function';
import { useMemo } from 'react';
import { FieldType } from 'modules/domains';
import { FieldOption } from 'modules/queryBuilder/legacyQueryBuilder/types';
import {
  CatalogFieldMappings,
  DefinedMappings,
  useCatalogFieldMappings,
} from './useCatalogFieldMappings';

const aggregateUndefined = (agg: DefinedMappings, field: string) => ({
  ...agg,
  [field]: FieldType.UNDEFINED,
});
const mapUndefinedFields = flow(array.reduce({}, aggregateUndefined));

const aggregateMappings = (data?: CatalogFieldMappings): FieldOption[] =>
  pipe(
    data,
    option.fromNullable,
    option.map(({ definedMappings, undefinedFields }) => {
      return {
        ...definedMappings,
        ...mapUndefinedFields(undefinedFields),
      };
    }),
    option.map(record.toEntries),
    option.map(
      array.map(([name, mapping]) => ({
        name,
        value: name,
        type: mapping,
      })),
    ),
    option.getOrElse<FieldOption[]>(() => []),
  );

export const useFetchCatalogFields = (name = '') => {
  const { data, ...other } = useCatalogFieldMappings(name);

  const fields = useMemo(() => aggregateMappings(data), [data]);

  return {
    ...other,
    data: fields,
  };
};
